import styled from '@emotion/styled'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import type React from 'react'
import { useEffect, useState } from 'react'
import type { AccountXYear } from '../api/swagger/definitions/backoffice'
import ColorsDeprecated from '../figma/tokens/ColorsDeprecated'
import Spacings from '../figma/tokens/Spacings'
import useLanguage from '../flamingo/hooks/useLanguage'
import type { AccountingFilters } from '../hooks/useAccountingFilters'
import TextKeys from '../libs/TextKeys'
import { YYYY_MM_DD } from '../mynt-components/Constants'
import FigmaBox from '../mynt-components/components/FigmaBox'
import FigmaButton from '../mynt-components/components/FigmaButton'
import { VOUCHERS_FILTERS_SELECT_INPUT_MIN_HEIGHT } from '../mynt-components/WeakHardCodedSizes'
import { getText } from '../tiger/libs/TextRepository'

interface AccountingVoucherFiltersProps {
  years: AccountXYear[]
  accountingFilters: AccountingFilters
  currencies: string[]
}

const VouchersFilters: React.FC<AccountingVoucherFiltersProps> = ({ years = [], accountingFilters, currencies = [] }) => {
  const language = useLanguage()

  const { fromDate, setFromDate, toDate, setToDate } = accountingFilters

  const [updatedFromDate, setUpdatedFromDate] = useState<string | undefined>(fromDate)
  const [updatedToDate, setUpdatedToDate] = useState<string | undefined>(toDate)

  // useEffect(() => {
  //   setUpdatedYearIds(yearIds)
  // }, [yearIds])

  useEffect(() => {
    setUpdatedFromDate(fromDate)
  }, [fromDate])

  useEffect(() => {
    setUpdatedToDate(toDate)
  }, [toDate])

  const handleOnFromDateSelect = (date) => {
    setUpdatedFromDate(date ? dayjs(date).format(YYYY_MM_DD) : '')
  }

  const handleOnToDateSelect = (date) => {
    setUpdatedToDate(date ? dayjs(date).format(YYYY_MM_DD) : '')
  }

  const handleSearchSubmit = () => {
    setFromDate(updatedFromDate)
    setToDate(updatedToDate)
  }

  return (
    <Wrapper fullWidth direction="row" justify="center" align="flex-start" gap={Spacings.medium}>
      <FigmaBox fullWidth>
        <DatePicker
          label={getText(TextKeys.vouchersFromDateLabel, language)}
          value={updatedFromDate ? dayjs(updatedFromDate) : null}
          format={YYYY_MM_DD}
          onChange={handleOnFromDateSelect}
          slots={{ textField: FixedDesktopDatePickerInput }}
        />
      </FigmaBox>
      <FigmaBox fullWidth>
        <DatePicker
          label={getText(TextKeys.vouchersToDateLabel, language)}
          value={updatedToDate ? dayjs(updatedToDate) : null}
          format={YYYY_MM_DD}
          onChange={handleOnToDateSelect}
          slots={{ textField: FixedDesktopDatePickerInput }}
        />
      </FigmaBox>
      <FigmaButton
        fullWidth={false}
        textKey={TextKeys.accountingVoucherCreateVoucher}
        text={'Search'}
        variant={'secondary'}
        onClick={handleSearchSubmit}
      />
    </Wrapper>
  )
}

const Wrapper = styled(FigmaBox)`
  .MuiSelect-select {
    min-height: ${VOUCHERS_FILTERS_SELECT_INPUT_MIN_HEIGHT} !important;
    padding-top: ${Spacings.min};
    padding-bottom: ${Spacings.min};
  }
`

const FixedDesktopDatePickerInput = styled(TextField)`
  button {
    margin-right: ${Spacings.minimum};
  }
`

const Item = styled(MenuItem)`
  && {
    cursor: pointer;
    color: ${ColorsDeprecated.baseGrey};
    padding-left: ${Spacings.small};
    padding-right: ${Spacings.small};

    &:hover {
      color: ${ColorsDeprecated.baseBlack};
      background-color: ${ColorsDeprecated.baseStone};
    }
  }
`

export default VouchersFilters
